module.exports = __webpack_public_path__ + "static/media/draft-posts.f7ec8101.svg";